import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  data: [],
  status: 'idle',
  error: null,
};
const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    addProduct: (state, action) => {
      state.data.push(action.payload);
    },
    editProduct: (state, action) => {
      state.data = state.data.map((product) =>
        product.id === action.payload.id ? action.payload : product,
      );
    },
    deleteProduct: (state, action) => {
      state.data = state.data.filter(
        (product) => product.id !== action.payload,
      );
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
    setError: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const {
  setProducts,
  addProduct,
  editProduct,
  deleteProduct,
  setLoading,
  setError,
} = productsSlice.actions;

export default productsSlice.reducer;
